import React /* , { useEffect, useRef } */ from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";

import useBookmark from "./useBookmark";

interface HistoryButtonProps {
  className?: string;
}

const BookmarkButton: React.FC<HistoryButtonProps> = ({ className = "" }) => {
  const bookmark = useBookmark();
  const savedLocation = bookmark.getSavedLocation();
  if (savedLocation) {
    return (
      <Button
        text={
          savedLocation.label ? `Go Back to ${savedLocation.label}` : "Go Back"
        }
        onClick={() => bookmark.navigateToSavedLocation()}
        variant="outlined"
        buttonType="secondary"
        style={{ whiteSpace: "nowrap" }}
        className={className}
      />
    );
  }
  return null;
};

export default BookmarkButton;
